import React, { useState, useEffect } from "react";
import "./stylesCotizadorProgrammaticFrecuencia.scss";

export const CotizadorProgrammaticFrecuencia = ({
  onFrecuenciaChange,
  isProgrammaticSelected,
  isDigitalSelected,
  selectedOption,
  horasSeleccionadas = 0,
  plazo,
  defaultFrecuencia,
  frecuencia,
  resetCounter,
}) => {
  const [selectedPaquete, setSelectedPaquete] = useState(defaultFrecuencia ? String(defaultFrecuencia) : "");

  // Sincronizar con la prop frecuencia y resetear cuando cambie resetCounter
  useEffect(() => {
    setSelectedPaquete(frecuencia ? String(frecuencia) : ""); // Sincronizar con la prop frecuencia
  }, [frecuencia, resetCounter]);

  useEffect(() => {
    if (defaultFrecuencia) {
      const frequencyAsString = String(defaultFrecuencia);
      setSelectedPaquete(frequencyAsString);
      onFrecuenciaChange(frequencyAsString);
    }
  }, [defaultFrecuencia, onFrecuenciaChange]);

  const handlePaqueteChange = (event) => {
    const value = event.target.value;
    setSelectedPaquete(value);
    onFrecuenciaChange(value);
  };

  // Matriz de recomendaciones según plazo y horas al aire
  // La correlación: menor tiempo al aire requiere mayor frecuencia para buen rendimiento
  const getRecommendedFrequency = () => {
    if (!isProgrammaticSelected && !isDigitalSelected) return null;
    if (plazo === 0) return null;
    if (!horasSeleccionadas) return null;

    if (isProgrammaticSelected || isDigitalSelected) {
      // Clasificar por horas reales:
      // - ≤1h: frecuencia máxima siempre (30)
      // - 1.5-2h: frecuencias muy altas
      // - 2.5-7h: frecuencias altas (AM/PM equivalente)
      // - >7h: frecuencias normales (Full Day equivalente)

      // Matriz de recomendaciones basada en horas reales:
      // | Plazo           | >7h (Full Day) | 2.5-7h (AM/PM) | 1.5-2h | ≤1h    |
      // |-----------------|----------------|----------------|--------|--------|
      // | ≥20 días (1mes) | 5              | 10             | 20     | 30     |
      // | 10-19 días      | 10             | 15             | 25     | 30     |
      // | 5-9 días        | 15             | 20             | 30     | 30     |
      // | <5 días         | 20             | 25             | 30     | 30     |

      const isFullDay = horasSeleccionadas > 7;
      const isMedium = horasSeleccionadas >= 2.5 && horasSeleccionadas <= 7;
      const isShort = horasSeleccionadas >= 1.5 && horasSeleccionadas < 2.5;
      const isVeryShort = horasSeleccionadas < 1.5;

      if (isVeryShort) return "30"; // ≤1h siempre máxima frecuencia

      if (plazo >= 20) {
        if (isFullDay) return "5";
        if (isMedium) return "10";
        if (isShort) return "20";
      } else if (plazo >= 10) {
        if (isFullDay) return "10";
        if (isMedium) return "15";
        if (isShort) return "25";
      } else if (plazo >= 5) {
        if (isFullDay) return "15";
        if (isMedium) return "20";
        if (isShort) return "30";
      } else {
        // Menos de 5 días: frecuencias altas
        if (isFullDay) return "20";
        if (isMedium) return "25";
        if (isShort) return "30";
      }
    }

    return null;
  };

  const recommendedFrequency = getRecommendedFrequency();

  const isRecommended = (value) => value === recommendedFrequency;

  return (
    <div className="frecuencia">
      <p className="titulofrecuencia">FRECUENCIA</p>
      <hr />
      <p className="subtitulo">
        SALIDAS POR HORA <br /> POR PANTALLA
      </p>
      <hr />
      {["5", "10", "15", "20", "25", "30"].map((freq) => (
        <div
          key={freq}
          style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "5px" }}
        >
          <span style={{ width: "24px", fontSize: "14px", textAlign: "right", marginRight: "10px" }}>
            {isRecommended(freq) ? "⭐️" : ""}
          </span>
          <label className="checkboxfrecuencia" style={{ margin: 0 }}>
            <input
              style={{ width: "15px", height: "15px", marginRight: "10px" }}
              checked={selectedPaquete === freq}
              name="paquete"
              onChange={handlePaqueteChange}
              type="checkbox"
              value={freq}
            />
            {freq}
          </label>
        </div>
      ))}
    </div>
  );
};
